import { render, staticRenderFns } from "./SHChangePeoplePopup.vue?vue&type=template&id=7f38bf26&"
import script from "./SHChangePeoplePopup.vue?vue&type=script&lang=ts&"
export * from "./SHChangePeoplePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports